<template>
    <div class="column-container d-flex order-lg-2 order-2 me-lg-auto">
        <OfferAmount />
    </div>

    <div v-if="offer?.apr_display?.formatted" class="column-container d-flex order-lg-3 order-3 me-lg-auto">
        <OfferRates />
    </div>

    <div v-if="offer?.term_display" class="column-container d-flex order-lg-4 order-4 me-lg-auto">
        <OfferTermCredit :show-label="true" />
    </div>

    <div v-if="offer.monthly_repayment_display" class="column-container d-flex order-lg-5 order-5 me-lg-auto">
        <OfferMonthlyRepayment :largeMobileValue="false" />
    </div>
</template>

<script>
export default {
    inject: ['offer'],
    computed: {
        territory: function () {
            return process.env.TERRITORY
        },
    },
}
</script>
